export * from './index-base.ts';

import { register } from './cjs/register.ts';

register();
